<div class="sidebar-sticky" *ngIf= "tocArray && ltiDeepLinkingMode">
	<div class="unit-header">
		<div class="main-header ml-2" *ngIf="!manageCustomLinks">
			<a href="javascript:void(0);" qid="ltiLinkPath-10" (click)="navigateBack()">
				<i aria-hidden="true" class="fa fa-angle-left"></i>
				<span class="sr-only"> {{ ('TEACHER.CREATE_ASSIGNMENTS.SCREEN_READER.GO_TO_COMPONENT_VIEW' | translate) }} </span>
			</a>
			<h1 container="body" title="{{productMeta.title}}">{{productMeta.title}}</h1>
			<a href="javascript:void(0);" class="ml-auto close-sidebar" qid="ltiLinkPath-1" (click)="toggleSideBar()">
				<i aria-hidden="true" class="nemo-font nemo-cross"></i>
				<span class="sr-only"> {{ ('TEACHER.CREATE_ASSIGNMENTS.SCREEN_READER.CLOSE_UNITVIEW_SIDEBAR' | translate) }} </span>
			</a>
		</div>
		<!-- for manage custom links page -->
		<div class="main-header ml-2" *ngIf="manageCustomLinks">
			<a href="javascript:void(0);" qid="ltiLinkPath-22" (click)="backToSelectContentView()">
				<i aria-hidden="true" class="fa fa-angle-left"></i>
				<span class="sr-only"> {{ ('TEACHER.CREATE_ASSIGNMENTS.SCREEN_READER.GO_TO_SELECT_CONTENT_VIEW' | translate) }} </span>
			</a>
			<h1 container="body" title="{{ 'TEACHER.CREATE_ASSIGNMENTS.MANAGE_CUSTOM_LINKS' | translate }}">{{ 'TEACHER.CREATE_ASSIGNMENTS.MANAGE_CUSTOM_LINKS' | translate }}</h1>
			<a href="javascript:void(0);" class="ml-auto close-sidebar" qid="ltiLinkPath-21" (click)="toggleSideBar()">
				<i aria-hidden="true" class="nemo-font nemo-cross"></i>
				<span class="sr-only"> {{ ('TEACHER.CREATE_ASSIGNMENTS.SCREEN_READER.CLOSE_UNITVIEW_SIDEBAR' | translate) }} </span>
			</a>
		</div>
	</div>
	<div class="toc-data-wrapper">
		<div class="deeplink-selection-container" *ngIf="!radioButtons && isCustomDeeplinksEnabled && !manageCustomLinks">
			<div class="radio-btn-container">
				<div class="mt-3 d-flex align-items-center">
					<span class="selection-text">
						{{ 'TEACHER.CREATE_ASSIGNMENTS.SELECT_CONTENT' | translate }}
					</span>
					<div class="position-relative">
						<div class="tooltip pl-3" tabindex="0" (keydown)="onTooltipKeydown($event)">
							<span>
								<em class="nemo-font nemo-info info-icon" [attr.aria-label] ="'TEACHER.CREATE_ASSIGNMENTS.MORE_INFORMATION' | translate"></em>
							</span>
						</div>
						<span class="tooltiptext">
							<a class="btn btn-link p-2 ml-auto position-absolute close-btn" href="javascript:void(0);" qid= "ltiLinkPath-31">
								<i aria-hidden="true" class="nemo-font nemo-cross"></i>
							</a>
							<p class="mb-0">
								<strong>{{ (isSpeakingCompanion ? 'TEACHER.CREATE_ASSIGNMENTS.BY_CATEGORY' : 'TEACHER.CREATE_ASSIGNMENTS.BY_UNIT') | translate }}:</strong>
								{{ (isSpeakingCompanion ? 'TEACHER.CREATE_ASSIGNMENTS.UNIT_DEEPLINK_TOOLTIP_TEXT_SPEAKING_COMPANION' : 'TEACHER.CREATE_ASSIGNMENTS.UNIT_DEEPLINK_TOOLTIP_TEXT') | translate }}
							</p>
							<p class="mb-0 mt-1">
								<strong>{{ 'TEACHER.CREATE_ASSIGNMENTS.CUSTOMISED' | translate }}:</strong>
								{{ (isSpeakingCompanion ? 'TEACHER.CREATE_ASSIGNMENTS.CUSTOM_DEEPLINK_TOOLTIP_TEXT_SPEAKING_COMPANION' : 'TEACHER.CREATE_ASSIGNMENTS.CUSTOM_DEEPLINK_TOOLTIP_TEXT') | translate }}
							</p>
						</span>
					</div>
				</div>
				<div class="d-flex pt-2 pb-2 flex-column">
					<div class="custom-control custom-radio mb-2">
						<input class="custom-control-input" type="radio" [(ngModel)]="deeplinkOption" id="unitDeeplink" qid="ltiLinkPath-15" name="deeplinkType" value="unit" (click)="deeplinkOption = 'unit'">
						<label for="unitDeeplink" class="custom-control-label deeplink-option d-inline pl-4">{{ (isSpeakingCompanion ? 'TEACHER.CREATE_ASSIGNMENTS.BY_CATEGORY' : 'TEACHER.CREATE_ASSIGNMENTS.BY_UNIT') | translate }}</label>
					</div>
					<div class="d-flex align-items-baseline">
						<div class="custom-control custom-radio">
							<input class="custom-control-input" type="radio" [(ngModel)]="deeplinkOption" id="customDeeplink" qid="ltiLinkPath-16" name="deeplinkType" value="custom" (click)="deeplinkOption = 'custom'">
							<label for="customDeeplink" class="custom-control-label deeplink-option custom-deeplink pl-4">{{ 'TEACHER.CREATE_ASSIGNMENTS.CUSTOMISED' | translate }}</label>
						</div>
						<a href="javascript:void(0);" class="view-custom-links" [ngClass]="{'disabled-link':deeplinkOption === 'unit','manage-custom-links': deeplinkOption === 'custom'}" (click)="deeplinkOption === 'custom' && manageCustomLinks=true;">
							{{ 'TEACHER.CREATE_ASSIGNMENTS.MANAGE_CUSTOM_LINKS' | translate }}
						</a>
					</div>
				</div>
				<!-- Maximum custom links container - show this if total assignments count exceeds limit in case of custom links -->
				<div class="max-custom-link-container" *ngIf="(totalAssignmentsCount >= totalAssignmentsLimit || isAssignmentsLOLimitReached) && deeplinkOption==='custom'">
					<ng-container  *ngIf="totalAssignmentsCount >= totalAssignmentsLimit; else loLimitReached">
						<p class="max-custom-link-heading-container">
							<i class="fa fa-warning pr-1" aria-hidden="true"></i>
							<span>
								{{ 'TEACHER.CREATE_ASSIGNMENTS.MAX_CUSTOM_LINKS_HEADING' | translate }}
							</span>
						</p>
						<p class="max-custom-link-desc ml-3 pl-1">
							{{ 'TEACHER.CREATE_ASSIGNMENTS.MAX_CUSTOM_LINKS_DESC' | translate }}
						</p>
						<a href="javascript:void(0);" qid= "ltiLinkPath-30" class="view-custom-links manage-custom-links ml-3 pl-1" (click)="manageCustomLinks=true;">
							{{ 'TEACHER.CREATE_ASSIGNMENTS.VIEW_CUSTOM_LINKS' | translate }}
						</a>
					</ng-container>
					<ng-template #loLimitReached>
						<p class="max-custom-link-heading-container">
							<i class="fa fa-warning pr-1" aria-hidden="true"></i>
							<span>
								{{ 'TEACHER.CREATE_ASSIGNMENTS.MAX_ASSIGNED_ACTIVITIES_HEADING' | translate }}
							</span>
						</p>	
						<p class="max-custom-link-desc ml-3 pl-1">
							{{ 'TEACHER.CREATE_ASSIGNMENTS.MAX_ASSIGNED_ACTIVITIES_DESC' | translate }}
						</p>
						<a href="javascript:void(0);" qid= "ltiLinkPath-32" class="view-custom-links manage-custom-links ml-3 pl-1" (click)="manageCustomLinks=true;">
							{{ 'TEACHER.CREATE_ASSIGNMENTS.MANAGE_CUSTOM_LINKS' | translate }}
						</a>
					</ng-template>
				</div>
			</div>	
		</div>
		<!-- Checkbox to give a select all functionality while creating deeplinks -->
		<div class="d-flex align-items-center py-3 select-all-checkbox" *ngIf="!radioButtons && deeplinkOption === 'unit'">
			<div class="custom-control custom-checkbox">
				<input type="checkbox" class="custom-control-input" id="lti-checkbox-all" (click)="selectAllUnits($event)" [indeterminate]="noOfCheckedUnits !== 0 && (totalUnitResourcesInProduct > 0 ? noOfCheckedUnits !== totalUnitResourcesInProduct : noOfCheckedUnits !== totalUnitFoldersInProduct)" [checked]="(totalUnitResourcesInProduct > 0 ? noOfCheckedUnits === totalUnitResourcesInProduct : noOfCheckedUnits === totalUnitFoldersInProduct)" qid="ltiLinkPath-13">
				<label class="custom-control-label" for="lti-checkbox-all">
					<span class="sr-only">{{ 'TEACHER.CREATE_ASSIGNMENTS.SELECT_ALL' | translate }}</span>
				</label>
			</div>
			<div class="select-all-unit-info w-100 d-flex align-items-center">
				<strong>
					{{ 'TEACHER.CREATE_ASSIGNMENTS.SELECT_ALL' | translate }}
				</strong>
				<span class="font-xs ml-auto mr-3 selected-units">
					{{noOfCheckedUnits}} {{ 'TEACHER.CREATE_ASSIGNMENTS.SELECTED' | translate }}
				</span>
			</div>
		</div>
		<ng-container *ngIf="(totalAssignmentsLimit > totalAssignmentsCount && !isAssignmentsLOLimitReached) || deeplinkOption==='unit'">
		<ng-container *ngFor="let unitLevelItem of tocArray;let unitIndex = index;">
			<ng-container *ngIf="unitLevelItem['item-type'] === 'folder' && !manageCustomLinks; else unitLevelActivity">
				<!-- hide the cards in case of custom links if total assignments count exceeds the limit -->
				<div class="card" [class]="{'indented': deeplinkOption === 'unit' && !radioButtons}">
					<div class="card-header">
						<div class="mb-0 accordian-heading p-0" container="body">
							<div class="d-flex unit-level-item">
								<div class="custom-control custom-checkbox" *ngIf="!radioButtons && deeplinkOption==='unit'">
									<input type="checkbox" class="custom-control-input" [id]="'lti-checkbox-' + unitLevelItem['item-code']" [name]="'lti-checkbox-' + unitLevelItem['item-code']" 
										(click)="selectUnitItems($event, unitLevelItem)" [checked]="unitLevelItem.isUnitChecked" [attr.qid]="'ltiLinkPath-12-' + unitIndex">
										<label class="custom-control-label" [for]="'lti-checkbox-' + unitLevelItem['item-code']">
										<span class="sr-only"> {{ 'TEACHER.CREATE_ASSIGNMENTS.SCREEN_READER.SELECT_UNIT' | translate }} </span>
									</label>
								</div>
								<a class="btn btn-link toggable-btn" href="javascript:void(0);" data-toggle="collapse"
									[attr.data-target]="'#createAssignCollapseUnitLevel' + unitIndex" [attr.qid]="'ltiLinkPath-17-' + unitIndex"
									aria-expanded="false">
									{{unitLevelItem.name}}
									<span
										*ngIf="deeplinkOption==='custom' && unitActivityCountHash[unitLevelItem['item-code']] != undefined &&  unitActivityCountHash[unitLevelItem['item-code']] != 0"
										class="unit-activity-count ml-2 mr-4 py-0">{{unitActivityCountHash[unitLevelItem['item-code']]}}</span>
								</a>
							</div>

							<div id="createAssignCollapseUnitLevel{{unitIndex}}" class="collapse">
								<div class="card-body">
									<ng-container *ngFor="let secondLevelItem of tocArray[unitIndex].items;let lessonIndex = index; first as isFirst;">
										<ng-container *ngIf="secondLevelItem['item-type'] === 'folder'; else secondLevelActivity">
											<div class="card">
												<div class="card-header">
													<div class="mb-0 accordian-heading d-flex ml-4" container="body">
														<div class="custom-control custom-checkbox" *ngIf="deeplinkOption==='custom' && !assignmentData.created && !radioButtons">
															<input type="checkbox" class="custom-control-input" [id]="'checkbox-' + secondLevelItem['item-code']" [disabled]="secondLevelItem.items.length === 0"
																[indeterminate]="secondLevelItem?.checkedItems !== 0 && secondLevelItem?.checkedItems !== secondLevelItem.items.length"
																[checked]="secondLevelItem?.checkedItems !== 0 && secondLevelItem?.checkedItems === secondLevelItem.items.length"
																[name]="'checkbox-' + secondLevelItem['item-code']" (click)=" selectLessonAllItems($event, secondLevelItem, tocArray[unitIndex]);"  [attr.qid]="'ltiLinkPath-7-' + unitIndex + '-' + lessonIndex">
																<label class="custom-control-label" [for]="'checkbox-' + secondLevelItem['item-code']">
																<span class="sr-only">{{ 'TEACHER.CREATE_ASSIGNMENTS.SCREEN_READER.SELECT_LESSON' | translate }}</span>
															</label>
														</div>
														<div *ngIf="assignmentData.created && secondLevelItem?.checkedItems !== 0 && secondLevelItem?.checkedItems === secondLevelItem.items.length" class="pt-1 success-text pr-2"> 
															<i class="nemo-font nemo-circle-tick" aria-hidden="true"></i>
															<span class="sr-only">{{ 'TEACHER.CREATE_ASSIGNMENTS.SCREEN_READER.LESSON_INCLUDED_SUCCESS' | translate }}</span>
														</div>
														<div class="lesson-info"> 
															<a class="btn btn-link toggable-btn lesson-type" href="javascript:void(0);"
																data-toggle="collapse" [attr.data-target]="'#collapseLessonLevel-' + unitIndex + '-' + lessonIndex" [attr.qid]="'ltiLinkPath-4-' + unitIndex + '-' + lessonIndex"
																[attr.aria-expanded]="false" (click)="changeCardBgColor($event)"
																[ngClass]="{'active': selectedItem.lessonId == secondLevelItem['item-code']}">
																{{secondLevelItem.name}}
															</a>
															<p *ngIf="deeplinkOption === 'custom' && secondLevelItem.showPreviousAssignedText" class="mb-0 previous-assigned-text">
																{{'TEACHER.CREATE_ASSIGNMENTS.PREVIOUSLY_ASSIGNED' | translate}}
															</p>
														</div>
													</div>
												</div>
												<div id="collapseLessonLevel-{{unitIndex}}-{{lessonIndex}}" class="collapse">
													<div class="card-body border-0">
														<div class="activity-name-container d-flex" *ngFor="let thirdLevelItem of secondLevelItem.items; let activityIndex = index;" [ngClass]="{'active': showActivity && selectedItem.activityId == thirdLevelItem['item-code']}" >
															<div class="custom-control custom-checkbox ml-4" *ngIf="deeplinkOption==='custom' && !(assignmentData.created && thirdLevelItem.isChecked)">
																<input type="checkbox" class="custom-control-input" [id]="'checkbox-' + thirdLevelItem['item-code']"
																	[(ngModel)]="thirdLevelItem.isChecked" [checked]="thirdLevelItem.isChecked"
																	[name]="'checkbox-' + thirdLevelItem['item-code']" (change)="onChangeItemCheckBox($event, thirdLevelItem, secondLevelItem, tocArray[unitIndex])" [attr.qid]="'ltiLinkPath-8-' + unitIndex + '-' + lessonIndex + '-' + activityIndex">
																	<label class="custom-control-label" [for]="'checkbox-' + thirdLevelItem['item-code']">
																	<span class="sr-only">{{ 'TEACHER.CREATE_ASSIGNMENTS.SCREEN_READER.SELECT_ACTIVITY' | translate }}</span>
																</label>
															</div>
															<div class="custom-control custom-checkbox ml-4" *ngIf="deeplinkOption==='unit' && radioButtons">
																<input type="checkbox" class="custom-control-input" [id]="'checkbox-' + thirdLevelItem['item-code']"
																	[name]="'checkbox-' + thirdLevelItem['item-code']" [attr.qid]="'ltiLinkPath-18-' + activityIndex"
																	(change)="onChangeTestItemCheckBox($event, thirdLevelItem)" [(ngModel)]="thirdLevelItem.isChecked" [checked]="thirdLevelItem.isChecked">
																<label class="custom-control-label" [for]="'checkbox-' + thirdLevelItem['item-code']">
																	<span class="sr-only">{{ 'TEACHER.CREATE_ASSIGNMENTS.SCREEN_READER.SELECT_ACTIVITY' | translate }}</span>
																</label>
															</div>
															<div *ngIf="deeplinkOption==='custom' && assignmentData.created && thirdLevelItem.isChecked" class="pt-3 success-text"> 
																<i class="nemo-font nemo-circle-tick" aria-hidden="true"></i>
																<span class="sr-only"> {{ 'TEACHER.CREATE_ASSIGNMENTS.SCREEN_READER.ACTIVITY_INCLUDED_SUCCESS' | translate }} </span>
															</div>
															<div class="activity-name"> 
																<a class="btn btn-link pt-0 pl-0 pb-0" href="javascript:void(0);" [attr.qid]="'ltiLinkPath-5-' + unitIndex + '-' + lessonIndex + '-' + activityIndex" (click)="launchActivity(thirdLevelItem)"  [ngClass]="{'active': selectedItem.activityId == thirdLevelItem['item-code']}" container="body">
																	<span> 
																		<span> {{thirdLevelItem.name}} </span>
																	</span>
																</a>
																<p *ngIf="deeplinkOption === 'custom' && thirdLevelItem.alreadyAssigned" class="mb-0 previous-assigned-text">
																	{{'TEACHER.CREATE_ASSIGNMENTS.PREVIOUSLY_ASSIGNED' | translate}}
																</p>
															</div>
															<div *ngIf="contentHelper.isGroupContent(thirdLevelItem) && 0 >= classGroupData?.entities?.length" class="warning-icon">
																<a qid="create-assignment-warning-info" href="javascript:void(0)" data-toggle="modal" data-target="#nogroupInClassModal" [attr.aria-label]="'TEACHER.CREATE_ASSIGNMENTS.SCREEN_READER.NO_GROUP_WARNING' | translate"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></a>
															</div>
														</div>
													</div>
												</div>
											</div> 
										</ng-container>
										<ng-template #secondLevelActivity>
											<div class="mb-0 accordian-heading d-flex lesson-activity" [ngClass]="{'isSCompSecondLevel': isSpeakingCompanion && deeplinkOption === 'unit', 'active': selectedItem.activityId == secondLevelItem['item-code']}" container="body">
												<!-- check if we need its else part too-->
												<div class="custom-control custom-checkbox ml-4" *ngIf="!assignmentData.created && radioButtons">
													<!-- Unit Deeplinking Mode -->
													<input *ngIf="deeplinkOption ==='unit'" type="checkbox" class="custom-control-input" [id]="'checkbox-' + secondLevelItem['item-code']"
														[(ngModel)]="secondLevelItem.isChecked" [checked]="secondLevelItem.isChecked"
														[name]="'checkbox-' + secondLevelItem['item-code']" (change)="onChangeTestItemCheckBox($event, secondLevelItem)"
														[attr.qid]="'ltiLinkPath-14-' + unitIndex + '-' + lessonIndex">
													<label *ngIf="deeplinkOption ==='unit'" class="custom-control-label" [for]="'checkbox-' + secondLevelItem['item-code']">
														<span class="sr-only">{{ 'TEACHER.CREATE_ASSIGNMENTS.SCREEN_READER.SELECT_ACTIVITY' | translate }}</span>
													</label>
												</div>
												<div class="custom-control custom-checkbox ml-4" *ngIf="deeplinkOption ==='custom' && isSpeakingCompanion" [ngClass]="{'already-assigned': secondLevelItem.allItemsAssigned}">
													<input type="checkbox" class="custom-control-input" [id]="'checkbox-' + secondLevelItem['item-code']"
														[(ngModel)]="secondLevelItem.isChecked" [checked]="secondLevelItem.isChecked"
														[name]="'checkbox-' + secondLevelItem['item-code']" (change)="onChangeScompCustomLinkCheckBox($event, secondLevelItem, tocArray[unitIndex])"
														[attr.qid]="'ltiLinkPath-33-' + unitIndex + '-' + lessonIndex">
													<label class="custom-control-label" [for]="'checkbox-' + secondLevelItem['item-code']">
														<span class="sr-only">{{ 'TEACHER.CREATE_ASSIGNMENTS.SCREEN_READER.SELECT_ACTIVITY' | translate }}</span>
													</label>
												</div>
												<div class="activity-name-container second-level-activity-container">
													<div class="activity-name">
														<a class="btn btn-link pt-0 pl-0 pb-0" href="javascript:void(0);"
															[attr.qid]="'ltiLinkPath-unit-act-' + '-' + unitIndex + '-' + lessonIndex"
															(click)="launchActivity(secondLevelItem)"
															[ngClass]="{'ml-2': deeplinkOption === 'unit'}">
															<span>{{secondLevelItem.name}}</span>
														</a>
													</div>
													<p *ngIf="deeplinkOption === 'custom' && secondLevelItem.alreadyAssigned" class="mb-0 previous-assigned-text">
														{{'TEACHER.CREATE_ASSIGNMENTS.PREVIOUSLY_ASSIGNED' | translate}}
													</p>
												</div>
											</div>
										</ng-template>
									</ng-container>
								</div>
							</div>
						</div>
					</div>
				</div>
			</ng-container>
			<ng-template #unitLevelActivity>
				<!-- Template for Speaking Companion/Test Component Level 1 -->
				<ng-container *ngIf="radioButtons || (!manageCustomLinks && isSpeakingCompanion)">
					<div class="mb-0 accordian-heading p-0 unit-activity m-0" [ngClass]="{'active': selectedItem.activityId == unitLevelItem['item-code']}" container="body">
						<div class="d-flex unit-level-item" [ngClass]="{'isSCompFirstLevel': isSpeakingCompanion && deeplinkOption === 'unit'}">
							<div class="custom-control custom-checkbox">
								<input type="checkbox" class="custom-control-input" [id]="'lti-checkbox-' + unitLevelItem['item-code']" [name]="'lti-checkbox-' + unitLevelItem['item-code']" 
									(click)="onChangeTestItemCheckBox($event, unitLevelItem)" [checked]="deeplinkOption === 'unit' ? unitLevelItem.isUnitChecked : unitLevelItem.isChecked"  [attr.qid]="'ltiLinkPath-19-' + unitIndex">
									<label class="custom-control-label" [for]="'lti-checkbox-' + unitLevelItem['item-code']">
									<span class="sr-only"> {{ 'TEACHER.CREATE_ASSIGNMENTS.SCREEN_READER.SELECT_UNIT' | translate }} </span>
								</label>
							</div>
							<div class="activity-name-container">
								<div class="activity-name">
									<a class="btn btn-link pt-0 pl-0 pb-0" href="javascript:void(0);"
										[attr.qid]="'ltiLinkPath-unit-act-' + '-' + unitIndex"
										(click)="launchActivity(unitLevelItem)"
										[ngClass]="{'ml-2': deeplinkOption === 'unit'}">
										<span>{{unitLevelItem.name}}</span>
									</a>
								</div>
								<p *ngIf="deeplinkOption === 'custom' && unitLevelItem.alreadyAssigned" class="mb-0 previous-assigned-text">
									{{'TEACHER.CREATE_ASSIGNMENTS.PREVIOUSLY_ASSIGNED' | translate}}
								</p>
							</div>
						</div>
					</div>
				</ng-container>
			</ng-template>
		</ng-container>
		</ng-container>
		<div *ngIf="manageCustomLinks" class="text-center">
			<div *ngIf="customLinks.length ==0">
				<img class="no-custom-links-image  mt-5 mb-2" src="{{imageBasePath}}assets/img/empty-scenario.svg" alt="{{'TEACHER.CREATE_ASSIGNMENTS.SCREEN_READER.NO_CUSTOM_LINKS_ICON' | translate}}">
				<p class="no-custom-links-heading">{{ 'TEACHER.CREATE_ASSIGNMENTS.NO_CUSTOM_LINKS_HEADING' | translate }}</p>
				<p class="mx-4 no-custom-links-desc">{{ 'TEACHER.CREATE_ASSIGNMENTS.NO_CUSTOM_LINKS_DESC' | translate }}</p>
				<button class="btn btn-main-color-1-bordered create-custom-link-btn m-auto" qid="ltiLinkPath-20"
					(click)="manageCustomLinks=false" [attr.aria-label]="'TEACHER.CREATE_ASSIGNMENTS.SCREEN_READER.CREATE_ASSIGNMENT' | translate">
					{{ 'TEACHER.CREATE_ASSIGNMENTS.CREATE_CUSTOM_LINK' | translate }}
				</button>
			</div>
			<div *ngIf="customLinks.length > 0">
				<ng-container *ngFor="let customLink of customLinks;let customLinkIndex = index;">
					<div class="card border-0">
						<div class="card-header">
							<div class="mb-0 accordian-heading p-0">
								<div class="d-flex assignment-level">
									<div class="custom-control custom-radio">
										<input type="radio" class="custom-control-input" [id]="'lti-radio-' + customLink['assigned_path_id']" name="lti-custom-link-radio"
											(click)="selectCustomLink(customLink)" [attr.qid]="'ltiLinkPath-25-' + customLinkIndex">
										<label class="custom-control-label" [for]="'lti-radio-' + customLink['assigned_path_id']">
											<span class="sr-only"> {{customLink.title}} </span>
										</label>
									</div>
									<a class="btn btn-link toggable-btn p-0 pr-3" href="javascript:void(0);" data-toggle="collapse" [attr.data-target]="'#collapseCustomLink-' + customLinkIndex"
										[attr.qid]="'ltiLinkPath-26-' + customLinkIndex" aria-expanded="false">
										{{customLink.title}}
									</a>
								</div>
								<div id="collapseCustomLink-{{customLinkIndex}}" class="collapse">
									<div class="card-body">
										<ng-container *ngFor="let unitLevelItem of customLink.items;let unitIndex = index;">
											<!-- Case 1: Root level activity (no unit folder) -->
											<ng-container *ngIf="unitLevelItem['item-type'] === 'resource'">
												<div class="activity-name-container d-flex"
													[ngClass]="{'active': showActivity && selectedItem.activityId == unitLevelItem['item-code']}">
													<div class="activity-name">
														<a class="btn btn-link pt-0 pl-0 pb-0" href="javascript:void(0);"
															[attr.qid]="'ltiLinkPath-root-'  + customLinkIndex + '-' + unitIndex"
															(click)="launchActivity(unitLevelItem)" [ngClass]="{'active': selectedItem.activityId == unitLevelItem['item-code']}">
															<span>{{unitLevelItem.name}}</span>
														</a>
													</div>
												</div>
											</ng-container>
											
											<!-- Case 2 & 3: Unit folder exists -->
											<div class="card border-0" *ngIf="unitLevelItem['item-type'] === 'folder'">
												<div class="card-header">
													<div class="mb-0 accordian-heading p-0">
														<div class="d-flex unit-level-item ml-3 border-0">
															<a class="btn btn-link toggable-btn p-0" href="javascript:void(0);" data-toggle="collapse"
																[attr.data-target]="'#customLinkCollapseUnitLevel-' + customLinkIndex + '-' + unitIndex"
																[attr.qid]="'ltiLinkPath-27-' + customLinkIndex + '-' + unitIndex" aria-expanded="false">
																{{unitLevelItem.name}}
															</a>
														</div>
														<div id="customLinkCollapseUnitLevel-{{customLinkIndex}}-{{unitIndex}}"
															class="collapse">
															<div class="card-body">
																<ng-container *ngFor="let secondLevelItem of unitLevelItem.items;let lessonIndex = index;">
																	<!-- Case 2: Activity directly under unit -->
																	<ng-container *ngIf="secondLevelItem['item-type'] === 'resource'">
																		<div class="activity-name-container d-flex"
																			[ngClass]="{'active': showActivity && selectedItem.activityId == secondLevelItem['item-code']}">
																			<div class="activity-name">
																				<a class="btn btn-link pt-0 pl-0 pb-0" href="javascript:void(0);"
																					[attr.qid]="'ltiLinkPath-unit-act-'  + customLinkIndex + '-' + unitIndex + '-' + lessonIndex"
																					(click)="launchActivity(secondLevelItem)" [ngClass]="{'active': selectedItem.activityId == secondLevelItem['item-code']}">
																					<span>{{secondLevelItem.name}}</span>
																				</a>
																			</div>
																		</div>
																	</ng-container>
																	
																	<!-- Case 3: Lesson folder with activities -->
																	<div class="card border-0" *ngIf="secondLevelItem['item-type'] === 'folder'">
																		<div class="card-header">
																			<div class="mb-0 accordian-heading d-flex ml-4 pl-4">
																				<div class="lesson-info">
																					<a class="btn btn-link toggable-btn lesson-type" href="javascript:void(0);" data-toggle="collapse"
																						[attr.data-target]="'#customLinkCollapseLessonLevel-' + customLinkIndex + '-' + unitIndex + '-' + lessonIndex"
																						[attr.qid]="'ltiLinkPath-28-' + customLinkIndex + '-' + unitIndex + '-' + lessonIndex"
																						[attr.aria-expanded]="false" (click)="changeCardBgColor($event)"
																						[ngClass]="{'active': selectedItem.lessonId == secondLevelItem['item-code']}">
																						{{secondLevelItem.name}}
																					</a>
																				</div>
																			</div>
																		</div>
																		<div id="customLinkCollapseLessonLevel-{{customLinkIndex}}-{{unitIndex}}-{{lessonIndex}}"
																			class="collapse">
																			<div class="card-body shadow-none">
																				<div class="activity-name-container d-flex"
																					*ngFor="let thirdLevelItem of secondLevelItem.items; let activityIndex = index;"
																					[ngClass]="{'active': showActivity && selectedItem.activityId == thirdLevelItem['item-code']}">
																					<div class="activity-name">
																						<a class="btn btn-link pt-0 pl-0 pb-0" href="javascript:void(0);"
																							[attr.qid]="'ltiLinkPath-29-'  + customLinkIndex + '-' + unitIndex + '-' + lessonIndex + '-' + activityIndex"
																							(click)="launchActivity(thirdLevelItem)" [ngClass]="{'active': selectedItem.activityId == thirdLevelItem['item-code']}">
																							<span>
																								<span>
																									{{thirdLevelItem.name}}
																								</span>
																							</span>
																						</a>
																					</div>
																				</div>
																			</div>
																		</div>
																	</div>
																</ng-container>
															</div>
														</div>
													</div>
												</div>
											</div>
										</ng-container>
									</div>
								</div>
							</div>
						</div>
					</div>
				</ng-container>
			</div>
		</div>
	</div>
	<!-- Hide create assignment wrapper in case of manage custom links section and if total assignments count exceeds the limit for custom links  -->
	<div  *ngIf="!manageCustomLinks && ((totalAssignmentsLimit > totalAssignmentsCount && !isAssignmentsLOLimitReached) || deeplinkOption==='unit')" class="create-assignment-wrapper">
		<div class="d-flex align-items-center" *ngIf="deeplinkOption==='custom'; else ltiButtonsContainer">
			<span class="font-xs">
				{{noOfCheckedItems}} {{ 'TEACHER.CREATE_ASSIGNMENTS.SELECTED' | translate }}
			</span>
			<button class="btn btn-lg btn-white ml-auto" qid="ltiLinkPath-6" [ngClass]="{'disabled': noOfCheckedItems === 0}" data-toggle="modal" data-target="#assignActivitiesModalForLti" (click)="setAssignment()" [attr.aria-label]="'TEACHER.CREATE_ASSIGNMENTS.SCREEN_READER.CREATE_ASSIGNMENT' | translate" [attr.tabindex]="noOfCheckedItems === 0 ? -1 : null">
				{{ 'TEACHER.CREATE_ASSIGNMENTS.ADD_LINK' | translate }}
				<i class="fa fa-angle-right ml-2" aria-hidden="true"></i>
			</button>
		</div>
		<ng-template #ltiButtonsContainer>
			<div class="d-flex align-items-center">
				<button class="btn btn-lg btn-white ml-auto" (click)="requestDeepLinkingForm()" qid="ltiLinkPath-11" [ngClass]="{'disabled': noOfCheckedUnits === 0 }" [attr.tabindex]="noOfCheckedUnits === 0 ? -1 : null">
					<ng-container *ngIf="1 >= noOfCheckedUnits">
						{{ 'TEACHER.CREATE_ASSIGNMENTS.ADD_LINK' | translate }}
					</ng-container>
					<ng-container *ngIf="noOfCheckedUnits >= 2">
						{{ 'TEACHER.CREATE_ASSIGNMENTS.ADD_LINKS' | translate }}
					</ng-container>
					<span *ngIf="noOfCheckedUnits >= 1">
						({{noOfCheckedUnits}})
					</span>
					<span *ngIf="showDeepLinkLoader">
						<i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
						<span class="sr-only">{{'TEACHER.CREATE_ASSIGNMENTS.SCREEN_READER.PROCESSING' | translate}}</span>
					</span>
					<i class="fa fa-angle-right ml-2" *ngIf="!showDeepLinkLoader" aria-hidden="true"></i>
				</button>
			</div>
		</ng-template>
	</div>
	<!-- for manage custom links page  -->
	<div  *ngIf="manageCustomLinks && this.customLinks.length > 0" class="create-assignment-wrapper d-flex">
			<button class="btn btn-lg btn-white-bordered cancel-button ml-auto" qid="ltiLinkPath-23" href="javascript:void(0);" [ngClass]="{'disabled': !selectedCustomLink}" data-toggle="modal" data-target="#deleteActivitiesModalForLti" [attr.aria-label]="'TEACHER.CREATE_ASSIGNMENTS.SCREEN_READER.CANCEL_BUTTON' | translate">
				{{'TEACHER.CREATE_ASSIGNMENTS.DELETE' | translate}}
			</button>
			<button class="btn btn-lg btn-white  ml-3 mr-2" (click)="relinkDeeplink(selectedCustomLink)" qid="ltiLinkPath-24" [ngClass]="{'disabled': !selectedCustomLink}">
				{{ ('TEACHER.CREATE_ASSIGNMENTS.RE_LINK' | translate) }}
				<span *ngIf="showDeepLinkLoader">
					<i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
					<span class="sr-only">{{'TEACHER.CREATE_ASSIGNMENTS.SCREEN_READER.PROCESSING' | translate}}</span>
				</span>
				<i class="fa fa-angle-right ml-2" *ngIf="!showDeepLinkLoader" aria-hidden="true"></i>
			</button>
	</div>
</div>

<!-- Assignment Limit Warning Modal Button -->
<a [hidden]="true" data-toggle="modal" data-target="#assignmentsLOLimitWarningModal" #assignmentsLOLimitWarningModalButton></a>